"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInfoBlockUrlProperty = exports.infoBlockUrlPropertyDefinition = void 0;
exports.infoBlockUrlPropertyDefinition = {
    view: {
        label: 'Link URL',
        hint: 'Link that directs the user to additional information, external resources, or actions related to the info block.',
    },
    constraints: [
        {
            name: 'orderedProperties',
            argument: ['info-block-url-text', 'info-block-url-link'],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'info-block-url',
};
const isInfoBlockUrlProperty = (prop) => {
    return prop.name === exports.infoBlockUrlPropertyDefinition.name;
};
exports.isInfoBlockUrlProperty = isInfoBlockUrlProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5mby1ibG9jay11cmwucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9pbmZvLWJsb2NrLXVybC5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLDhCQUE4QixHQUFHO0lBQzVDLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxVQUFVO1FBQ2pCLElBQUksRUFBRSxpSEFBaUg7S0FDeEg7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxtQkFBbUI7WUFDekIsUUFBUSxFQUFFLENBQUMscUJBQXFCLEVBQUUscUJBQXFCLENBQUM7U0FDekQ7S0FDRjtJQUNELElBQUksRUFBRSxtQkFBbUI7SUFDekIsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsZ0JBQWdCO0NBQ1MsQ0FBQTtBQUkxQixNQUFNLHNCQUFzQixHQUFHLENBQUMsSUFBa0IsRUFBZ0MsRUFBRTtJQUN6RixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssc0NBQThCLENBQUMsSUFBSSxDQUFBO0FBQzFELENBQUMsQ0FBQTtBQUZZLFFBQUEsc0JBQXNCLDBCQUVsQyJ9